// extracted by mini-css-extract-plugin
export default {"header":"MainNavigation_header__A+kIW","active":"MainNavigation_active__A3hGx"};